import { cn } from "@/utils";
import { Avatar, Card, CardBody, CardFooter, CardHeader } from "@heroui/react";

export const LimeTimeline = ({
  highlightFirst = true,
  items,
}: {
  highlightFirst?: boolean;
  items: {
    id?: React.Key;
    title?: string | React.ReactNode;
    description: string | React.ReactNode;
    timestamp: string;
    user?: {
      fullName: string;
      imageUrl?: string;
    };
    icon?: React.ReactNode;
  }[];
}) => {
  return (
    <div className="flex flex-col gap-2">
      {items.map((item, index) => (
        <Card
          key={item.id ?? `${item.timestamp}-${index}`}
          shadow="none"
          className={cn(
            "bg-background relative overflow-visible border-2 border-gray-100",
            {
              "pl-4": item.icon != null,
              "border-primary": highlightFirst && index === 0,
            },
          )}
        >
          <CardHeader className="pb-0">
            <div className="flex w-full items-center justify-between">
              <p className="text-sm font-medium">{item.title}</p>
              <p className="text-xs text-gray-500">{item.timestamp}</p>
            </div>
          </CardHeader>
          <CardBody>
            {typeof item.description === "string" ? (
              <p className="text-sm text-gray-500">{item.description}</p>
            ) : (
              item.description
            )}
          </CardBody>
          {item.user != null && (
            <CardFooter className="pt-0">
              <div className="flex items-center gap-2">
                <Avatar size="sm" src={item.user?.imageUrl} />
                <p className="text-sm font-medium">{item.user?.fullName}</p>
              </div>
            </CardFooter>
          )}

          {item.icon != null && (
            <div
              className={cn(
                "bg-background absolute top-1/2 -left-4 flex h-8 w-8 -translate-y-1/2 transform items-center justify-center rounded-full border-2 border-gray-100 p-0.5",
                {
                  "border-primary": highlightFirst && index === 0,
                },
              )}
            >
              {item.icon}
            </div>
          )}
        </Card>
      ))}
    </div>
  );
};
